import CustomDataArea from './CustomDataArea';

const ArrDepCustomData = ({ customData }) => {
  return <CustomDataArea customData={customData} />;
};

export default ArrDepCustomData;
